import { useLayoutEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import './PdfDocumentPreview.css';

// Use the same PDF.js renderer and worker as the app's regulatory PDF reader.
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

export default function PdfDocumentPreview({ file, onReady, maxPages = Infinity, renderTextLayer = true }) {
  const container = useRef(null);
  const [width, setWidth] = useState(0);
  const [pages, setPages] = useState(0);

  useLayoutEffect(() => {
    const element = container.current;
    const measure = () => setWidth(Math.max(1, element.clientWidth));
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return <div className="pdfDocumentPreview" ref={container}>
    <Document file={file}
      loading={<div className="pdfDocumentPreviewStatus">Loading document...</div>}
      error={<div className="pdfDocumentPreviewStatus" role="alert">Unable to load this PDF.</div>}
      onLoadError={onReady}
      onLoadSuccess={({ numPages }) => setPages(numPages)}>
      {width > 0 && Array.from({ length: Math.min(pages, maxPages) }, (_, index) => <Page
        key={index + 1} pageNumber={index + 1} width={width}
        renderAnnotationLayer={false} renderTextLayer={renderTextLayer}
        canvasBackground="#ffffff"
        onRenderSuccess={index === 0 ? onReady : undefined}
        onRenderError={onReady}
        error={<div className="pdfDocumentPreviewStatus" role="alert">Unable to display this page.</div>}
      />)}
    </Document>
  </div>;
}
